import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
// Redux
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
// Style
import { Button } from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import CommonFormComponent from '../../CommonField/CommonFormComponent';
import { getCurrencySymbol } from '../../../helpers/currencyConvertion';
import submit from './submit';
import validate from './validate';

import cs from '../../../components/commonStyle.css';
import s from './ServiceFeesForm.css';
import messages from '../../../locale/jsonMessages';
class ServiceFeesForm extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    title: PropTypes.string.isRequired,
    base: PropTypes.string.isRequired,
    availableCurrencies: PropTypes.arrayOf(PropTypes.shape({
      symbol: PropTypes.string.isRequired
    })).isRequired
  };

  render() {

    const { error, handleSubmit, submitting, dispatch, initialValues, currentLocale, currency } = this.props;
    const { base, availableCurrencies, guestType, hostType } = this.props;
    const { formatMessage } = this.props.intl;
    let symbol = getCurrencySymbol(currency, currentLocale);

    return (
      <div>
        <h1 className='siteAdminHeading'><FormattedMessage  {...messages.manageServiceFee} /></h1>
        <form onSubmit={handleSubmit(submit)}>
          {error && <strong>{formatMessage(error)}</strong>}
          <div className="oneColumnGrid">
            <div className='twoColumnGrid'>
              <div className={cx(cs.adminBorderWithoutPadding)}>
                <div className={cx(s.cardHeader)}>
                  <p className={cx(cs.commonSubTitleText, cs.fontWeightBold)}><FormattedMessage  {...messages.guestLabel} /></p>
                </div>
                <div className={cx(s.cardBodyStyle)}>
                  <div className={cs.spaceBottom12}>
                    <div className='commonLabelText'>
                      <FormattedMessage  {...messages.feeTypeLabel} />
                    </div>
                    <div className='customRatioButton commonRadioBtnFlexGroup'>
                      <label className='commonRadioFlex'>
                        <Field name="guestType" component="input" type="radio" value="fixed" />
                        <span className='siteAdminRadioText'><FormattedMessage  {...messages.fixedPrice} /></span>
                      </label>

                      <label className='commonRadioFlex'>
                        <Field name="guestType" component="input" type="radio" value="percentage" />
                        <span className='siteAdminRadioText'><FormattedMessage  {...messages.percentage} /></span>
                      </label>
                    </div>
                  </div>
                  <div>
                    <Field name="guestValue"
                      type="text"
                      isAddon={true}
                      prefixLabel={guestType == 'fixed' ? symbol : '%'}
                      component={CommonFormComponent}
                      labelText={formatMessage(messages.serviceFeeLabel)}
                      placeholder={formatMessage(messages.serviceFeeLabel)}
                      isRequiredInput
                    />
                  </div>
                </div>
              </div>

              <div className={cx(cs.adminBorderWithoutPadding)}>
                <div className={cx(s.cardHeader)}>
                  <p className={cx(cs.commonSubTitleText, cs.fontWeightBold)}><FormattedMessage  {...messages.hostLabel} /></p>
                </div>
                <div className={cx(s.cardBodyStyle)}>
                  <div className={cs.spaceBottom12}>
                    <div className='commonLabelText'>
                      <FormattedMessage  {...messages.feeTypeLabel} />
                    </div>
                    <div className='customRatioButton commonRadioBtnFlexGroup'>
                      <label className='commonRadioFlex'>
                        <Field name="hostType" component="input" type="radio" value="fixed" />
                        <span className='siteAdminRadioText'><FormattedMessage  {...messages.fixedPrice} /></span>
                      </label>

                      <label className='commonRadioFlex'>
                        <Field name="hostType" component="input" type="radio" value="percentage" />
                        <span className='siteAdminRadioText'><FormattedMessage  {...messages.percentage} /></span>
                      </label>
                    </div>
                  </div>
                  <div>
                    <Field name="hostValue"
                      type="text"
                      isAddon={true}
                      prefixLabel={hostType == 'fixed' ? symbol : '%'}
                      component={CommonFormComponent}
                      labelText={formatMessage(messages.serviceFeeLabel)}
                      placeholder={formatMessage(messages.serviceFeeLabel)}
                      isRequiredInput
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className='twoColumnGrid'>
              <Field name="currency"
                component={CommonFormComponent}
                placeholder={formatMessage(messages.chooseCurrency)}
                labelText={formatMessage(messages.chooseCurrency)}
                inputClass='commonSelectField'>
                <option value="">{formatMessage(messages.chooseCurrency)}</option>
                {
                  availableCurrencies && availableCurrencies?.length > 0 && availableCurrencies?.map((currency, key) => {
                    if (currency.isEnable === true) {
                      return <option key={key} value={currency.symbol}>{currency.symbol}</option>
                    }
                  })
                }
              </Field>
            </div>
          </div>

          <div className={cx(cs.spaceTop4, 'singleBtnFlexEnd')}>
            <Button className={cx(cs.btnPrimary)} type="submit" disabled={submitting} ><FormattedMessage  {...messages.save} /></Button>
          </div>
        </form>
      </div>
    );
  }

}

ServiceFeesForm = reduxForm({
  form: 'ServiceFeesForm', // a unique name for this form
  validate
})(ServiceFeesForm);

const selector = formValueSelector('ServiceFeesForm'); // <-- same as form name

const mapState = (state) => ({
  availableCurrencies: state.currency.availableCurrencies,
  base: state.currency.base,
  currentLocale: state.intl.locale,
  currency: selector(state, 'currency'),
  guestType: selector(state, 'guestType'),
  hostType: selector(state, 'hostType'),
});

const mapDispatch = {
};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(ServiceFeesForm)));